import { Component } from 'react'
import PropTypes from 'prop-types'

class Button extends Component {

  render() {
    return (
      <button
        className={this.props.className}
        onClick={this.props.onClick}>
        {this.props.children}
      </button>
    )
  }
}

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired
}

export default Button
